import React from 'react';
import { format, formatDistanceToNow } from 'date-fns';

const TimeCell = ({ timestamp, fontSize = 12, textAlign='left' }) => {
    let unixTimestamp;

    // Check if the timestamp is a string in ISO 8601 format
    if (typeof timestamp === 'string') {
        // Convert ISO string to Date and then to Unix timestamp in milliseconds
        const dateObj = new Date(timestamp);
        unixTimestamp = dateObj.getTime() / 1000; // Convert to seconds
    } else {
        // If timestamp is already in Unix time (seconds), use it as is
        unixTimestamp = timestamp;
    }

    // Convert Unix timestamp to Date object
    const date = new Date(unixTimestamp * 1000);

    // Check if the date is valid
    const isValidDate = !isNaN(date.getTime());

    let formattedDate, datePart, timePart, relativeTime;

    if (isValidDate) {
        // Format date as '2/14/2023, 9:01 PM'
        formattedDate = format(date, 'M/d/yyyy, h:mm a');

        // Split the formatted date into date and time for separate lines
        [datePart, timePart] = formattedDate.split(', ');

        // Get relative time (e.g., '1 hour ago')
        relativeTime = formatDistanceToNow(date, { addSuffix: true });
    } else {
        datePart = "--";
        timePart = "";
        relativeTime = "";
    }

    return (
        <div style={{ textAlign }}>
            <div style={{ fontSize, fontFamily: 'var(--font-title)', fontWeight: '400', color: isValidDate ? 'inherit' : 'red' }}>
                {datePart} {timePart}
            </div>
            {isValidDate && (
                <div style={{ fontSize: fontSize, fontFamily: 'var(--font-title)' }}>
                    {`(${relativeTime})`}
                </div>
            )}
        </div>
    );
};

export default TimeCell;
